import dayjs from 'dayjs';

export const MAX_YEARLY_DEPOSIT = 81711;

export function calcMaxOneTime(monthlyDepositSum) {
  const monthsUntilEndOfYear = 12 - dayjs().month();
  return Math.max(MAX_YEARLY_DEPOSIT - (monthlyDepositSum * monthsUntilEndOfYear), 0);
}
